export default __webpack_public_path__ + "static/cardTabImg1-43cf59c790e23c9332613b71b7b305a7.webp";